"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LandingModal;
(function (LandingModal) {
    LandingModal[LandingModal["Closed"] = 0] = "Closed";
    LandingModal[LandingModal["Login"] = 1] = "Login";
    LandingModal[LandingModal["SuccessPopup"] = 2] = "SuccessPopup";
    LandingModal[LandingModal["Register"] = 3] = "Register";
    LandingModal[LandingModal["ForgotPassword"] = 4] = "ForgotPassword";
    LandingModal[LandingModal["Video"] = 5] = "Video";
})(LandingModal = exports.LandingModal || (exports.LandingModal = {}));


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/LandingStore.ts
// module id = 474
// module chunks = 0 1 2